import { VerificationServiceDetailsState } from "@idw-types/state/verification-service-details-state";
import { VerificationServiceDetailsActionTypes, VerificationServiceDetailsActions } from "../actions/verification-service-details-actions";

export const initialVerificationServiceDetailsState: VerificationServiceDetailsState = {
    verificationServiceDetails: {
        verificationServiceDetails: null,
        isLoading: false
    }
};

export const verificationServiceDetailsReducer = (
    state: VerificationServiceDetailsState = initialVerificationServiceDetailsState,
    action: VerificationServiceDetailsActions
): VerificationServiceDetailsState => {
    switch (action.type) {
        case VerificationServiceDetailsActionTypes.SET_VERIFICATION_SERVICE_DETAILS_LOADING:
            return {
                ...state,
                verificationServiceDetails: {
                    ...(action.payload.isLoading
                        ? { ...initialVerificationServiceDetailsState.verificationServiceDetails }
                        : { ...state.verificationServiceDetails }),
                    isLoading: action.payload.isLoading
                }
            };
        case VerificationServiceDetailsActionTypes.SET_VERIFICATION_SERVICE_DETAILS:
            return {
                ...state,
                verificationServiceDetails: {
                    verificationServiceDetails: action.payload.verificationServiceDetails,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};